import type { ServiceName } from "@/types/service";
import { HomeBeautyServiceModal } from "./home-beauty-service-modal";
import { LashesServiceModal } from "./lashes-service-modal";

export const ChoosePackageModal = ({ name }: { name: ServiceName }) => {
  if (name === "home-beauty") return <HomeBeautyServiceModal />;
  if (name === "lashes") return <LashesServiceModal />;
};
